// components/use-case-details/use-case-tldr.tsx
"use client";

import { ReactNode } from "react";


interface UseCaseTLDRSectionProps {
  children: ReactNode;
  bordered?: boolean;
  borderColor?: string;
}

export function UseCaseTLDRSection({ 
  children, 
  bordered = true,
  borderColor = "bg-teal" 
}: UseCaseTLDRSectionProps) {
  return (
    // <div className="relative my-10 p-6 bg-bg-dark rounded-xl border border-gray-700 shadow-lg">
    <div className="relative my-10   rounded-xl  shadow-lg">
      {/* Top border as a separate element for cleaner styling */}
      {bordered && <div className={`absolute top-0 left-0 right-0 h-2 ${borderColor}`} />}
      <h2 className="text-3xl font-display font-bold text-white mb-4 flex items-center pt-2">
        <span className="bg-teal-500 text-medium-emphasis px-2 py-1 rounded-md text-sm mr-3">TLDR</span>
        Summary of what we are covering
      </h2>
      <div className="text-gray-300 text-xl">
        {children}
      </div>
    </div>
  );
}

// interface UseCaseSidebarProps {
//   details: {
//     vertical: string;
//     aiModels: string;
//     implementationType: string;
//     problemSolved: string;
//     implementationTime: string;
//     complexity: string;
//     techStack: string[];
//   };
//   relatedCases: {
//     title?: string;
//     slug?: string;
//     category?: string;
//     model?: string;
//     focus?: string;
//   }[];
//   industrySlug?: string;
// }

// export function UseCaseSidebar({
//   details,
//   // relatedCases,
//   // industrySlug = "architecture"
// }: UseCaseSidebarProps) {
//   return (
//       <div className="bg-dark-gray rounded-lg p-6">
//         <div className="sticky top-32">
//           <h3 className="text-xl font-bold text-white mb-4">Use Case Details</h3>
//           <div className="space-y-4">
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Vertical</h4>
//               <p className="text-white">{details.vertical}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">AI Models</h4>
//               <p className="text-white">{details.aiModels}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Implementation Type</h4>
//               <p className="text-white">{details.implementationType}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Problem Solved</h4>
//               <p className="text-white">{details.problemSolved}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Implementation Timeline</h4>
//               <p className="text-white">{details.implementationTime}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Complexity</h4>
//               <p className="text-white">{details.complexity}</p>
//             </div>
            
//             <div>
//               <h4 className="text-sm font-medium text-light-gray mb-1">Tech Stack</h4>
//               <div className="flex flex-wrap gap-2 mt-2">
//                 {details.techStack.map((tech, index) => (
//                   <Badge 
//                     key={index} 
//                     className={index === 0 ? "bg-teal text-black" : "bg-black"}
//                   >
//                     {tech}
//                   </Badge>
//                 ))}
//               </div>
//             </div>
//           </div>
          
//           {/* <Separator className="my-6 bg-medium-gray" /> */}
          
//         </div>
//       </div>
      
//   );
// }